export default "__VITE_ASSET__DlzmEeq7__"